var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#E42D2D",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.5C8 20.0102 8.29746 21.5056 8.87539 22.9009C9.45331 24.2961 10.3004 25.5639 11.3683 26.6317C12.4361 27.6996 13.7039 28.5467 15.0991 29.1246C16.4944 29.7025 17.9898 30 19.5 30C21.0102 30 22.5056 29.7025 23.9009 29.1246C25.2961 28.5467 26.5639 27.6996 27.6317 26.6317C28.6996 25.5639 29.5467 24.2961 30.1246 22.9009C30.7025 21.5056 31 20.0102 31 18.5C31 16.9898 30.7025 15.4944 30.1246 14.0991C29.5467 12.7039 28.6996 11.4361 27.6317 10.3683C26.5639 9.3004 25.2961 8.45331 23.9009 7.87539C22.5056 7.29746 21.0102 7 19.5 7C17.9898 7 16.4944 7.29746 15.0991 7.87539C13.7039 8.45331 12.4361 9.3004 11.3683 10.3683C10.3004 11.4361 9.45331 12.7039 8.87539 14.0991C8.29746 15.4944 8 16.9898 8 18.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.459 26.721C13.1666 25.7308 14.983 24.9416 16.872 24.369C17.709 24.06 17.8 22.14 17.2 21.48C16.334 20.527 15.6 19.41 15.6 16.714C15.5495 16.1769 15.6137 15.6352 15.7882 15.1247C15.9626 14.6142 16.2435 14.1466 16.6121 13.7527C16.9807 13.3588 17.4288 13.0477 17.9266 12.8398C18.4244 12.632 18.9607 12.5322 19.5 12.547C20.0393 12.5322 20.5755 12.632 21.0734 12.8398C21.5712 13.0477 22.0192 13.3588 22.3879 13.7527C22.7565 14.1466 23.0373 14.6142 23.2118 15.1247C23.3863 15.6352 23.4504 16.1769 23.4 16.714C23.4 19.414 22.666 20.527 21.8 21.48C21.2 22.14 21.291 24.06 22.128 24.369C24.017 24.9416 25.8334 25.7308 27.541 26.721",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.cd66d1dec35d3b010561582f3ea9e093.svg";
export { ForwardRef as ReactComponent };